import { useToast } from "@/hooks/use-toast"
import {
  Toast,
  ToastClose,
  ToastDescription,
  ToastProvider,
  ToastTitle,
  ToastViewport,
} from "@/components/ui/toast"

export function Toaster() {
  const { toasts } = useToast()

  return (
    <ToastProvider>
      {toasts.map(function ({ id, title, description, action, ...props }) {
        return (
          <Toast key={id} {...props}>
        <div className="flex flex-col items-center text-center gap-2">
  <div className="w-14 h-14 rounded-full bg-white/20 flex items-center justify-center text-2xl">
    🎉
  </div>

  {title && (
    <ToastTitle className="text-lg font-bold text-white">
      {title}
    </ToastTitle>
  )}

  {description && (
    <ToastDescription className="text-sm text-white/90">
      {description}
    </ToastDescription>
  )}
</div>

            {action}
            <ToastClose />
          </Toast>
        );
      })}
      <ToastViewport />
    </ToastProvider>
  );
}
